<template>
  <div class="app">
    <Card dis-hover>
      <div class="page-body">
        <Form ref="queryForm" :label-width="90" label-position="left" inline>
            <FormItem label="关键词:">
              <Input v-model="query.keyword" placeholder="账号名/员工姓名" style="width: 160px"></Input>
            </FormItem>
            <FormItem label="工号:">
              <Input v-model="query.number"  style="width: 160px" placeholder="请输入工号"></Input>
            </FormItem>
            <FormItem label="事业部:" >
              <Input v-model="query.causeDepartment" style="width: 160px" placeholder="请输事业部"></Input>
            </FormItem>
            <FormItem label="部门:" >
              <Input v-model="query.Department" style="width: 160px" placeholder="请输部门"></Input>
            </FormItem>
            <FormItem label="岗位:">
              <Select placeholder="请选择岗位"  style="width: 160px" v-model="query.post">
                <Option value="">------</Option>
                <Option v-for="item in postList" :key="item.value" :value="item.value">{{ item.name }}</Option>
              </Select>
            </FormItem>
            <FormItem label="在职状态:">
              <Select placeholder="请选择在职状态"  style="width: 160px" v-model="query.workStatus">
                <Option value="">------</Option>
                <Option v-for="item in workStatusList" :key="item.value" :value="item.value">{{ item.name }}</Option>
              </Select>
            </FormItem>
            <FormItem :label-width="0">
              <Button icon="ios-search" type="primary" size="default" @click="getpage(1)" class="toolbar-btn">查询</Button>
              <Button icon="md-refresh" type="primary" size="default" @click="reset" class="toolbar-btn">重置</Button>
              <!-- <Button @click="exportFile" icon="md-archive" type="primary" size="default" class="toolbar-btn">导出</Button> -->
            </FormItem>
        </Form>
        <div>
          <Table :loading="loading" :columns="columns" no-data-text="暂无数据" border :data="list"></Table>
          <Page show-sizer show-total class-name="fengpage" :total="totalCount" class="margin-top-10" @on-change="pageChange" @on-page-size-change="pagesizeChange" :page-size="pageSize" :current="currentPage"></Page>
        </div>
      </div>
    </Card>
	<!-- 出货评审 -->
	<div v-if='showDetail'>
		<UpdatePersonnel :showDetail="showDetail" :personnelId="personnelId" @close="closeCreateProjectModel"/>
	</div>
  </div>
</template>

<script>
import {
  getPersonnelListData,
  getPostSaleListInitInfo,
  confirmDelivery,
  getAfterPerson,
} from '../../../api/index'
import moment from 'moment'
import Util from '../../../lib/util'
import UpdatePersonnel from './updatePersonnel'

export default {
  name: 'personnel',
  data() {
    return {
      query: {
		keyword: '',
		number: '',
		causeDepartment:'',
		department:'',
		post:null,
		workStatus:null,
		
		MaxResultCount: 10,
		SkipCount: 0,
      },
      loading: false,
      columns: [],
      list: [],
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
	  
	  postList: [], //岗位list
	  workStatusList: [], //在职状态list
	  
	  personnelId:0,
      showDetail: false, //详情弹框
      showCreate: false, //创建弹框
    }
  },
  components: {
	 UpdatePersonnel 
  },
  mounted() {
	  this.getUserSelectList()
    this.getpage()
    this.getColumn()
  },
  methods: {
	  //获取下拉框
	  async getUserSelectList() {
	    const { data } = await this.$Ajax.get(
	      '/api/services/app/User/GetPersonnelInitData'
	    )
	    this.postList = data.result.postList
	    this.workStatusList = data.result.workStatusList
	  },
    
    async getpage(params) {
      this.query.MaxResultCount = this.pageSize
      this.query.SkipCount = (this.currentPage - 1) * this.pageSize
      if (params === 1) {
        this.query.SkipCount = 0
      }
      this.loading = true
      const res = await getPersonnelListData(this.query)
      this.list = res.data.result.items
      this.totalCount = res.data.result.totalCount
      this.loading = false
    },
    reset() {
      // 清空所有属性值
      Object.keys(this.query).forEach((key) => (this.query[key] = ''))
    },
    //新增模具弹框
    createSale() {
      this.showCreate = true
    },
    //表格
    getColumn() {
      let _this = this
      this.columns = [
    {
      title: '员工姓名',
      key: 'name',
    },
    {
      title: '工号',
      key: 'number',
    },
    {
      title: '事业部',
      key: 'causeDepartment',
    },
    {
      title: '部门',
      key: 'department'
    },
    {
      title: '岗位',
	  key: 'postText'
    },
    {
      title: '入职日期',
	  key: 'joinedCompanyDateText'
    },
    {
      title: '在职状态',
	  key: 'workStatusText'
    },
    {
        title: '操作',
        width: 240,
        fixed: 'right',
        render: (h, params) => {
          return h('div', { style: 'paddingTop:5px;' }, [
            h(
              'Button',
              {
                props: {
                  type: 'primary',
                  size: 'small',
                },
                on: {
                  click: () => {
                    this.openUpdatePersonnel(params.row.id)
                  },
                },
              },
              '编辑'
            ),
    //         h(
    //           'Button',
    //           {
    //             props: {
    //               type: 'error',
    //               size: 'small',
    //             },
    //             style: {
    //               marginRight: '5px',
    //               display: params.row.isDelete ? '' : 'none',
    //             },
    //             on: {
    //               click: () => {
    //                 this.$Modal.confirm({
    //                   title: '确认删除“' + params.row.productName + '”吗？',
    //                   okText: '确认',
    //                   cancelText: '取消',
    //                   onOk: async () => {
    //                     this.isShowDelete = true
    
    //                     const { data } = await this.$Ajax.delete(
    //                       `/api/services/app/ProjectManageService/DeleteProduct?id=${params.row.id}`
    //                     )
    
    //                     if (data.success) {
    //                       this.$Message.success({ content: '删除成功', duration: 5 })
    //                     } else {
    //                       this.$Message.error({ content: '删除失败', duration: 5 })
    //                     }
    //                     this.isShowDelete = false
    //                     this.getpage()
    //                   },
    //                 })
    //               },
    //             },
    //           },
    //           '删除'
    //         ),
          ])
        },
      },
    
  ]
    },
    
    //分页
    pageChange(page) {
      this.currentPage = page
      this.getpage()
    },
    pagesizeChange(pagesize) {
      this.pageSize = pagesize
      this.getpage()
    },
    // 打开编辑
    openUpdatePersonnel(personnelId) {
		console.log(personnelId);
      this.personnelId = personnelId
      this.showDetail = true
    },
	
	//关闭弹框
	closeCreateProjectModel(refresh) {
	  this.showDetail = false
	  if (refresh) {
	    this.getpage()
	  }
	},
    exportFile() {
      var _this = this
      console.log(_this.query)
      if (!_this.query.DesignName) {
        _this.query.DesignName = ''
      }
      if (!_this.query.Name) {
        _this.query.Name = ''
      }
      if (!_this.query.MouldName) {
        _this.query.MouldName = ''
      }
      if (!_this.query.StartCreationTime) {
        _this.query.StartCreationTime = ''
      }
      if (!_this.query.EndCreationTime) {
        _this.query.EndCreationTime = ''
      }
      if (!_this.query.Status) {
        _this.query.Status = ''
      }
      if (!_this.query.MouldNO) {
        _this.query.MouldNO = ''
      }
      if (!_this.query.CauseDepartment) {
        _this.query.CauseDepartment = ''
      }
      if (!_this.query.Type) {
        _this.query.Type = ''
      }
    //   const date = this.$moment(new Date()).format('yyyyMMDDHHmm')
    //   let consturl = `${this.$constDefinition.baseUrl}/api/Export/ExportPostSaleList?
    //                         DesignName=${_this.query.DesignName}
    //                         &Name=${_this.query.Name}
    //                         &MouldName=${_this.query.MouldName}
    //                         &StartCreationTime=${_this.query.StartCreationTime}
    //                         &EndCreationTime=${_this.query.EndCreationTime}
    //                         &Status=${_this.query.Status}
    //                         &MouldNO=${_this.query.MouldNO}
    //                         &CauseDepartment=${_this.query.CauseDepartment}
    //                         &Type=${_this.query.Type}` //下载地址url
    //   var xhr = new XMLHttpRequest()
    //   xhr.open('get', consturl, true) // get、post都可
    //   xhr.responseType = 'blob'
    //   xhr.setRequestHeader('Authorization', `Bearer ${Util.abp.auth.getToken()}`) //加请求头
    //   xhr.onload = function () {
    //     if (xhr.status == 200) {
    //       let blob = new Blob([this.response], {
    //         type: 'application/vnd.ms-excel',
    //       })
    //       var a = document.createElement('a')
    //       var url = window.URL.createObjectURL(blob)
    //       a.href = url
    //       a.download = `产品列表${date}.xlsx` // 文件名
    //     }
    //     a.click()
    //     window.URL.revokeObjectURL(url)
    //   }
    //   xhr.send()

      
        this.$downLoad('/api/Export/ExportPostSaleList', '产品列表', '.xlsx',  this.query)
    },
  },
}
</script>

<style lang="less" scoped>
.app {
  min-width: 1260px;
}
.ivu-upload {
  display: inline-block;
}
.ivu-btn {
  margin-left: 5px;
}
.spin {
  font-size: 20px;
}
</style>
